import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Socket } from 'ngx-socket-io';
import { firstValueFrom, Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

import { AuthService } from '../login/auth.service';
import {
  CreateFolderDto,
  Folder,
  FolderProductImage,
  MoveFolderDto,
  UpdateFolderDto
} from 'src/typings';
import { CurrentUserService as UserService } from '../user/user.service';

@Injectable({
  providedIn: 'root'
})
export class FolderService {
  constructor(
    private http: HttpClient,
    private authService: AuthService,
    private userService: UserService,
    private socket: Socket
  ) {}

  foldersUpdatedGw = this.socket.fromEvent<Folder[]>('folder_updated');

  getNestedListFolders(): Observable<Folder[]> {
    return this.http.get<Folder[]>(`${environment.BACKEND}/folder/nested_list`);
  }

  getFlatFolders(): Observable<Folder[]> {
    return this.http.get<Folder[]>(`${environment.BACKEND}/folder/flat_list`);
  }

  create(payload: CreateFolderDto): Observable<Folder> {
    return this.http.post<Folder>(`${environment.BACKEND}/folder/create`, payload);
  }

  updateFolder(payload: UpdateFolderDto) {
    return this.http.put<Folder>(`${environment.BACKEND}/folder/update`, payload);
  }

  moveFolder(payload: MoveFolderDto) {
    return this.http.put<Folder>(`${environment.BACKEND}/folder/move`, payload);
  }

  getProductImages(folderId: number): Observable<FolderProductImage[]> {
    return this.http.get<FolderProductImage[]>(
      `${environment.BACKEND}/folder/${folderId}/product-images`
    );
  }

  delete(id: number) {
    const resp = this.http.delete<void>(`${environment.BACKEND}/folder/${id}`);
    return resp;
  }

  async uploadImage(file: File) {
    const imageName = await firstValueFrom(this.userService.uploadFile(file));
    return imageName.name;
  }
}
